/* eslint-disable import/prefer-default-export */
export function convertFromParamToType(param, lang) {
  switch (param) {
    case 'van':
    case 'struck':
    case 'mtruck':
      return { type: 'van', inSameFile: true };
    case 'mudou':
    case 'ton1':
    case 'ton2':
      return { type: '5ton', inSameFile: true };
    case 'mudou9':
    case 'ton3':
    case 'ton4':
    case 'ton5':
    case 'ton6':
      return { type: '9ton', inSameFile: true };
    case 'delivery':
      if (lang === 'kr') {
        return { type: 'smallfreight', inSameFile: false };
      }
      return { type: 'courier', inSameFile: false };
    case 'transport':
      if (lang === 'kr') {
        return { type: 'courier', inSameFile: false };
      }
      return { type: 'ridewithgoodsicon', inSameFile: false };
    case 'big_cargo':
      return { type: 'deliveryservice', inSameFile: false };
    case 'moving':
      return { type: 'movingservice', inSameFile: false };
    case 'motorcycle':
      return { type: 'motorcycle', inSameFile: false };
    default:
      return param;
  }
}

// remove orderDetailInfo key
export function removeByKey(myObj, deleteKey) {
  return Object.keys(myObj)
    .filter(key => key !== deleteKey)
    .reduce((result, current) => {
      const res = result;
      res[current] = myObj[current];
      return result;
    }, {});
}



// WEBPACK FOOTER //
// ./src/ctrl/orderCtrl.js